import React from 'react';
export function Header() {
  return <header className="w-full bg-white/80 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50" data-id="element-85">
      <div className="max-w-4xl mx-auto px-4 py-4 flex justify-between items-center" data-id="element-86">
        <div className="text-xl font-bold text-gray-800" data-id="element-87">Kit RRHH en Orden</div>
        <a href="#compra" className="bg-gradient-to-r from-pink-400 to-rose-400 text-white px-6 py-2 rounded-full text-sm font-medium hover:shadow-lg transition-all duration-300" data-id="element-88">
          Comprar ahora
        </a>
      </div>
    </header>;
}